// extracted by mini-css-extract-plugin
export default {"errorSection":"AmpOnboardingPage_errorSection__qB1o9","mainSection":"AmpOnboardingPage_mainSection__Y9K5j"};